<template>
  <div class="out-container">
    <div ref="titleRef" class="title" v-if="title && !subTitle">
      {{ title }}
    </div>
    <div ref="titleRef" class="sub-title" v-if="title && subTitle">
      <div class="parent-title" @click="backFront">{{ title }}</div>
      <div class="line">/</div>
      <div class="current-title">
        {{ subTitle }}
      </div>
    </div>
    <slot name="title"></slot>
    <el-card class="box-card" shadow="never">
      <div class="ml-table">
        <div ref="filterRef" class="filter-container">
          <div
            class="filter-item"
            :class="{ isDate: filter.component === 'DateRange' }"
            v-for="(filter, index) in topFilters"
            :key="index"
          >
            <div class="label">{{ filter.label }}</div>
            <slot
              v-if="filter.slot"
              :name="filter.slot"
              class="filter-item"
              :listQuery="listQuery"
            ></slot>
            <component
              v-else-if="filter.component"
              v-model="listQuery[filter.prop]"
              :is="filter.component"
              :start.sync="listQuery[filter.start]"
              :end.sync="listQuery[filter.end]"
              v-bind="filter"
            >
            </component>
            <el-input
              v-else
              v-model="listQuery[filter.prop]"
              clearable
              :placeholder="filter.placeholder || filter.label"
              @keyup.enter.native="getList(true)"
            ></el-input>
          </div>
          <div class="search-container">
            <el-button type="primary" v-loading="loading" @click="getList(true)"
              >搜索</el-button
            >
          </div>
        </div>
        <div
          ref="actionRef"
          class="actions-area"
          v-if="defaultConfig.actions?.length > 0"
        >
          <div class="left">
            <el-button
              class="btn"
              v-for="(action, index) in defaultConfig.actions"
              :key="index"
              v-bind="action.config"
              @click="action.click"
            >
              <img
                class="action-img"
                v-if="action.config.img"
                :src="action.config.img"
              />
              <span>{{ action.label }}</span>
            </el-button>
          </div>
        </div>
        <div class="table-border">
          <el-table
            v-show="tableHeight > 0"
            ref="mlTable"
            :data="list"
            :height="tableHeight"
            size="mini"
            v-loading="loading"
            element-loading-text="加载中..."
            @sort-change="handleSortChange"
            @row-click="handleRowClick"
            :show-summary="showSummary"
            :summary-method="getSummaries"
            @selection-change="handleSelectionChange"
            highlight-current-row
            :span-method="
              ({ row, column, rowIndex, columnIndex }) =>
                spanMethod(row, column, rowIndex, columnIndex, list)
            "
            v-on="$listeners"
            border
          >
            <template v-if="config.columns.length > 0">
              <el-table-column
                v-if="indexWidth > 0"
                type="index"
                :width="indexWidth"
                align="left"
                label="序号"
                :fixed="indexFixed"
              >
              </el-table-column>
              <el-table-column
                type="selection"
                width="43"
                align="center"
                fixed
                v-if="showSelection"
              >
              </el-table-column>
              <template v-for="(colConfig, index) in config.columns">
                <template v-if="colConfig.isShow !== false">
                  <slot
                    v-if="colConfig.slot"
                    :name="colConfig.slot"
                    :config="colConfig"
                  ></slot>

                  <!-- :show-overflow-tooltip="true" -->
                  <el-table-column
                    v-else
                    :key="index"
                    v-bind="colConfig"
                    v-on="$listeners"
                    :sortable="colConfig.sortable"
                    :class-name="colConfig.className"
                    :width="colConfig.width ? colConfig.width : ''"
                    :min-width="colConfig.minWidth ? colConfig.minWidth : ''"
                  >
                  </el-table-column>
                </template>
              </template>
            </template>
          </el-table>
        </div>
        <div class="pagination-container" ref="paginationContainer">
          <el-pagination
            background
            :pager-count="pagination.pageCount"
            :current-page="listQuery.pageNum"
            :layout="pagination.layout"
            :page-sizes="pagination.pageSizes"
            :page-size="listQuery.pageSize"
            :total="total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { windowOnresize } from '@/utils/fnc';

let pagination = {
  pageSizes: [20, 50, 200, 1000],
  pageSize: 20,
  pageCount: 5,
  layout: 'total, sizes, prev, pager, next, jumper',
};

const query = {
  pageNum: 1,
  pageSize: pagination.pageSize,
};

export default {
  name: 'MlTable',
  components: {},
  props: {
    url: {
      // 查询的地址
      type: String,
      required: true,
    },
    title: {
      // 表格名称
      type: String,
    },
    subTitle: {
      // 表格副标题
      type: String,
    },
    pageName: {
      type: String,
    },
    indexWidth: {
      // 序号宽度
      type: Number,
      default: 80,
    },
    offsetTop: {
      // 表格偏移量
      type: Number,
      default: 0,
    },
    mountQuery: {
      // 是否在初始化完成后查询
      type: Boolean,
      default: false,
    },
    showSummary: {
      // 是否显示合计
      type: Boolean,
      default: false,
    },
    showSelection: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      default: 0,
    },
    needCloneKeys: {
      type: Array,
      default: () => {
        return [];
      },
    },
    defaultConfig: {
      type: Object,
      required: true,
      default: () => {
        return {
          columns: [], // 表格显示列
          listQuery: undefined,
          actions: [],
        };
      },
    },
    spanMethod: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      pagination,
      tableHeight: null,
      list: [],
      loading: false,
      config: {
        columns: [], // 表格显示列
        listQuery: undefined,
        actions: [],
      },
      listQuery: { ...query },
      total: 0,
      indexFixed: false,
    };
  },
  computed: {
    ...mapGetters(['organizationInfo']),
    topFilters() {
      const filters = [];
      this.config.columns.forEach((val) => {
        if (val.filter) {
          val.filter.label = val.filter.label || val.label;
          val.filter.prop = val.filter.prop || val.prop || val.sot;
          filters.push(val.filter);
        }
      });
      return filters;
    },
  },
  watch: {
    'config.columns'() {
      setTimeout(() => {
        this.doLayout();
      }, 500);
    },
    'defaultConfig.listQuery': {
      handler(val) {
        this.refresh();
      },
      deep: true,
    },
  },

  async mounted() {
    this.config = JSON.parse(JSON.stringify(this.defaultConfig));
    if (this.mountQuery) {
      this.getList(true);
    }
    windowOnresize(this.doLayout);
  },
  methods: {
    /**
     * 通过点击标题回到上一级
     * */
    backFront() {
      this.$router.push({
        name: this.pageName,
      });
    },
    /**
     * 动态计算表格高度
     */
    doLayout() {
      if (this.height > 0) {
        this.tableHeight = this.height;
      } else {
        setTimeout(() => {
          const titleH = this.$refs.titleRef?.clientHeight || 0;
          const filterH = this.$refs.filterRef?.clientHeight || 0;
          const actionH = this.$refs.actionRef?.clientHeight || 0;
          const pH = this.$refs.paginationContainer?.clientHeight || 0;
          this.tableHeight =
            window.innerHeight -
            titleH -
            filterH -
            actionH -
            pH -
            60 -
            80 -
            this.offsetTop;
          this.indexFixed = true;
        }, 100);
      }
    },
    async refresh() {
      this.listQuery = { ...query };
      this.getList(true);
    },
    /**
     * 表格查询条件
     */
    buildQuery() {
      const params = {
        ...this.listQuery,
        ...(this.defaultConfig.listQuery || {}),
      };
      Object.keys(params).forEach((key) => {
        if (
          params[key] === '' ||
          params[key] === null ||
          params[key] === undefined
        ) {
          delete params[key];
        }
      });
      return params;
    },
    async getList(reset = false) {
      if (!this.url || this.loading) return;
      this.loading = true;
      if (reset) {
        this.listQuery.pageNum = 1;
      }
      const params = this.buildQuery();
      const res = await this.$http.post(this.url, params);
      this.loading = false;
      if (res?.data) {
        const list = res.data.list || [];
        if (this.needCloneKeys.length > 0) {
          list.forEach((row) => {
            this.needCloneKeys.forEach((key) => {
              if (row.hasOwnProperty(key)) {
                row[key + '_clone'] = row[key];
              }
            });
          });
        }
        this.list = list;
        this.total = res.data.total;
      }
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList();
    },
    /**
     * 排序条件变化
     */
    handleSortChange(e) {
      console.log('排序=====');
      console.log(e);
    },
    /**
     * 点击某一行数据
     */
    handleRowClick(e) {},
    getSummaries() {},
    handleSelectionChange() {},
  },
};
</script>
<style lang="scss" scoped>
.ml-table {
  transform: translateZ(0);
  backface-visibility: hidden;
  position: relative;

  .filter-container {
    display: flex;
    // flex-wrap: wrap;
    justify-content: flex-start;
    padding-bottom: 20px;
    .filter-item {
      flex: 1;
      max-width: 300px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-right: 20px;
      .label {
        max-width: 88px;
        flex-shrink: 0;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        padding-right: 10px;
        display: inline-block;
        height: 32px;
        line-height: 32px;
        // text-align: justify;
        &::after {
          content: '';
          display: inline-block;
          width: 100%;
        }
      }
      &.isDate {
        // width: 347px;
        .el-date-editor {
          // width: 276px;
          ::v-deep .el-range-input {
            width: 50%;
          }
        }
      }
    }
    .search-container {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-bottom: 10px;
    }
  }

  .actions-area {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 20px;
    .left {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .btn {
        ::v-deep span {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
      }
    }
    .right {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      .filter-item-mini {
        width: 230px;
        border: 1px solid #ccd0d8;
        border-radius: 4px;
        margin-left: 10px;
        ::v-deep .el-input__inner {
          border: none;
        }
        .input {
          display: flex;
          ::v-deep .el-loading-spinner {
            top: 8px;
            margin-top: 0;
            .circular {
              width: 16px;
              height: 16px;
            }
          }
          .search-icon {
            width: 45px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 13px;
              height: 13px;
            }
          }
          .search-icon:hover {
            cursor: pointer;
            img {
              width: 16px;
              height: 16px;
            }
          }
        }
        &.mini-isDate {
          // width: 347px;
          .el-date-editor {
            padding-right: 0;
            // width: 276px;
            ::v-deep .el-range-input {
              width: 50%;
            }
            ::v-deep .el-range-separator {
              padding: 0 2px;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-table__body tr.hover-row > td.el-table__cell,
  .el-table__body tr.hover-row.current-row > td.el-table__cell,
  .el-table__body tr.hover-row.el-table__row--striped > td.el-table__cell,
  .el-table__body
    tr.hover-row.el-table__row--striped.current-row
    > td.el-table__cell {
    background-color: rgba($color: #f5f7fa, $alpha: 0.5) !important;
  }

  .el-table__body {
    td {
      height: 40px;
      line-height: 40px;
    }
  }

  .el-table .caret-wrapper {
    position: absolute;
    top: -5px;
    right: 5px;
  }

  .el-table__footer .el-table_1_column_1 {
    font-size: 12px;
    color: #606266;
    font-weight: normal;
  }

  .input-with-select {
    .el-input-group__append,
    .el-input-group__prepend {
      .el-input--suffix {
        width: 94px;
        padding-right: 22px;
      }
    }

    .search-component {
      .el-input {
        width: 166px;

        &.is-focus {
          .el-input__inner {
            border-color: #dcdfe6 !important;
          }
        }
      }
    }

    .el-input-group--append .el-input__inner {
      width: 240px;
    }

    .el-input-group__append,
    .el-input-group__prepend {
      padding: 0 15px 0 20px;
    }
  }

  .tags {
    margin-top: 5px;

    .el-tag {
      margin-right: 5px;
    }
  }

  .more-search {
    border: none;
    color: #4074e1;
  }

  // .pagination-container {
  //   display: flex;

  //   .el-pagination {
  //     padding: 6px 0 0 0;
  //   }
  //   .el-input__inner {
  //     height: 28px !important;
  //   }
  // }

  .pagination-container {
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;

    .el-pagination {
      padding-right: 4px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      // .el-pagination__sizes {
      //   height: 36px;
      // }

      // .el-pagination__jump {
      //   height: 36px;
      // }
    }
  }

  .action {
    flex: 1;
    /*border: 1px solid #e6ebf5;*/
    /*border-bottom: none;*/
    /*!*border-top: none;*!*/

    /*background: #ffffff;*/
    button {
      //margin: 5px 0 5px 5px;
    }

    &:after {
      content: ' ';
      display: block;
      clear: both;
    }
  }

  .setting {
    /*float: right;*/
    i {
      font-size: 16px;
    }

    margin-right: 5px;
  }
}
</style>
